/**
 * Formats a date value to a readable string format
 * @param {Date|string|number} value - The date value to format
 * @param {Object} options - Formatting options
 * @returns {string} The formatted date string
 */
export const formatDateTime = (value, options = {}) => {
    if (!value) return '';
    
    const defaultOptions = {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    };
    
    const formatOptions = { ...defaultOptions, ...options };
    
    try {
        return new Date(value).toLocaleString('en-US', formatOptions);
    } catch (error) {
        console.error('Error formatting date:', error);
        return '';
    }
};

/**
 * Formats a date value to date only (no time)
 * @param {Date|string|number} value - The date value to format
 * @returns {string} The formatted date string
 */
export const formatDate = (value) => {
    return formatDateTime(value, { day: 'numeric', month: 'numeric', year: 'numeric', hour: undefined, minute: undefined, hour12: undefined });
};

/**
 * Formats a date value to time only (no date)
 * @param {Date|string|number} value - The date value to format
 * @returns {string} The formatted time string
 */
export const formatTime = (value) => {
    return formatDateTime(value, { day: undefined, month: undefined, year: undefined });
};

Object.defineProperty(Date.prototype, 'toRegularDate', {
  value: function () {
    const dd = String(this.getDate()).padStart(2, '0');
    const mm = String(this.getMonth() + 1).padStart(2, '0');
    const yyyy = this.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  },
  enumerable: false,
});

Object.defineProperty(String.prototype, 'toRegularDate', {
  value: function () {
    const d = new Date(this);
    return d.toRegularDate();
  },
  enumerable: false,
});

Object.defineProperty(Number.prototype, 'toRegularDate', {
  value: function () {
    const d = new Date(this);
    return d.toRegularDate();
  },
  enumerable: false,
});

Object.defineProperty(Date.prototype, 'toRegularDateTime', {
  value: function () {
    const day = String(this.getDate()).padStart(2, '0');
    const month = String(this.getMonth() + 1).padStart(2, '0');
    const year = this.getFullYear();

    let hours = this.getHours();
    const minutes = String(this.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;
    const hourStr = String(hours).padStart(2, '0');

    return `${day}-${month}-${year} ${hourStr}:${minutes} ${ampm}`;
  },
  enumerable: false,
});

Object.defineProperty(String.prototype, 'toRegularDateTime', {
  value: function () {
    const d = new Date(this);
    return d.toRegularDateTime();
  },
  enumerable: false,
});

Object.defineProperty(Number.prototype, 'toRegularDateTime', {
  value: function () {
    const d = new Date(this);
    return d.toRegularDateTime();
  },
  enumerable: false,
});